import React, { useMemo, useState, useContext } from 'react';
import Typography from '@mui/material/Typography';
import { Tabs, Form } from 'antd';
import MainCard from 'components/MainCard';
import InspectionForm from './Tabs/InspectionForm';

import TechnicalSheetHTML from './Tabs/TechnicalSheetHTML';
import { UserContext } from '../../contexts/UserContext';
import { useLocation, useParams } from 'react-router';
import { formatGraceEndDate, getSubscriptionAccess } from '../../utils/subscription';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';


export default function MasterTab({ onFormValidated }) {
  const [inspectionForm] = Form.useForm();
  const [activeKey, setActiveKey] = useState('1');
  const [formData, setFormData] = useState(null); // store validated data
 const { showToast, user } = useContext(UserContext);

 const { id } = useParams();
const { state } = useLocation();
const incomingData = state?.record || null
console.log('Record passed:', id,incomingData );
  const subscriptionAccess = useMemo(() => getSubscriptionAccess(user), [user]);
  const graceEndDate = useMemo(
    () => formatGraceEndDate(user?.limits?.inspection_expiry_date ?? user?.inspection_expiry_date),
    [user]
  );

  if (user?.role === 'user' && !subscriptionAccess.canCreateInspection) {
    return (
      <MainCard title="Add Inspection">
        <Stack spacing={1.5}>
          <Typography variant="body1">
            Subscription expired. You can view existing reports{graceEndDate ? ` until ${graceEndDate}` : ''}, but cannot add new inspections.
          </Typography>
          <Button variant="contained" component={Link} to="/dashboard/inspection-list">
            Go to Inspection List
          </Button>
        </Stack>
      </MainCard>
    );
  }

  const handleTabChange = async (key) => {
    if (key === '1') {
      setActiveKey('1');
      return;
    }

    try {
      await inspectionForm.validateFields();  

      const rawData = inspectionForm.getFieldsValue();
      const formattedData = {
        ...rawData,
        inspection_date: rawData.inspection_date?.format('YYYY-MM-DD hh:mm:ss') || null
      };


      setFormData(formattedData); // store locally
      onFormValidated?.(formattedData); // pass to parent if needed
      showToast('Inspection form validated successfully!','success');
      setActiveKey(key);
    } catch (err) {
      showToast('Please complete all required fields before proceeding.','error');
    }
  };

  const tabItems = [
    {
      key: '1',
      label: 'Inspection',
      children: (
        <Form form={inspectionForm} layout="vertical" name="inspectionForm">
          <InspectionForm form={inspectionForm} incomingData={incomingData}/>
        </Form>
      ),
    },
    {
      key: '2',
      label: 'Wear measurement data input',
      children: (
        <Typography variant="body2">
          <TechnicalSheetHTML inspectionData={formData} />
        </Typography>
      ),
    },
    // {
    //   key: '3',
    //   label: 'Export Report',
    //   children: (
    //     <Typography variant="body2">
    //       Export Report content goes here. Include export buttons or summary charts.
    //     </Typography>
    //   ),
    // },
    // {
    //   key: '4',
    //   label: 'Summary',
    //   children: (
    //     <Typography variant="body2">
    //       Summary content goes here. Wrap up insights or show final metrics.
    //     </Typography>
    //   ),
    // },
  ];

  return (
    <MainCard title="Add Inspection">
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        type="line"
        items={tabItems}
      />
    </MainCard>
  );
}
